import { render } from "./PermitsMenuWithOrWithoutLls.vue?vue&type=template&id=5a0c6d84"
import script from "./PermitsMenuWithOrWithoutLls.vue?vue&type=script&lang=js"
export * from "./PermitsMenuWithOrWithoutLls.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__